import { withLocale } from "@lib/i18n/pagesRouter";
import { Cobranded } from "@components/Cobranded";
import type { Shell } from "@components/SiteShell";
import { ParsedPartner } from "@justhome/common";
import { config } from "@lib/config";
import { Page } from "@lib/generated/graphql";
import { getParsedPartner } from "@lib/partner";
import { getAlternateLanguageHref } from "@lib/routing";
import { getShellProps } from "@components/SiteShell/getShell";
import getPageData from "@lib/strapi/getPageData";
import getStaticSectionData from "@modules/homepage/sections/InterestRateChart/getStaticSectionData";
import { serverSideTranslations } from "next-i18next/serverSideTranslations";
import { Locale } from "next/router";
import Index from "../../[[...slug]]";

function PartnerPage({
  page,
  sectionData,
  preview,
  partner,
  shell,
  locale,
  partnerSlug,
}: {
  page: Page;
  sectionData: any;
  preview: boolean;
  partner: ParsedPartner;
  shell: Shell;
  locale: Locale;
  partnerSlug: string;
}) {
  return (
    <Cobranded partner={partner}>
      <Index
        shell={shell}
        page={page}
        sectionData={sectionData}
        preview={preview}
        isPartner
        locale={locale}
        alternateLanguageHref={getAlternateLanguageHref(
          locale,
          page.localizations,
          "page",
          `/partner/${partnerSlug}`,
        )}
      />
    </Cobranded>
  );
}
export default PartnerPage;

type Params = {
  params: {
    slug: string;
    partner: string;
  };
  locale: string;
  preview?: boolean;
};

export type StaticPathsProps = {
  locales: string[];
  defaultLocale: string;
};

export async function getStaticPaths() {
  return {
    paths: [],
    fallback: "blocking",
  };
}

async function getLocalizedStaticProps({ params, locale, preview }: Params) {
  const pageData = await getPageData({
    slug: params.slug,
    locale,
    publicationState: preview ? "PREVIEW" : "LIVE",
  });
  const partner = await getParsedPartner(params.partner);
  const shell = await getShellProps(locale);
  const page = pageData.attributes;

  if (!(page && partner)) {
    return {
      notFound: true,
    };
  }

  const sectionData = await getStaticSectionData(page.contentSections);

  return {
    props: {
      ...(await serverSideTranslations(locale)),
      page,
      sectionData,
      shell,
      preview: !!preview,
      partner,
      partnerSlug: params.partner,
    },
    revalidate: config.cms.revalidate,
  };
}

export const getStaticProps = withLocale(getLocalizedStaticProps);
